import api from "./api";

const divisions = {
  getDivisions() {
    return api.get(`/divisions/`);
  },
  addDivisions(args) {
    return api.post(`/divisions/`, args);
  },
  editDivisions(args, id) {
    return api.patch(`/divisions/${id}`, args);
  },
  deleteDivisions(id) {
    return api.delete(`/divisions/${id}`);
  },
};

export default divisions;
